export default __webpack_public_path__ + "static/frankowski-7c82fa22ea52034cf44af807aa070e2e.jpg";